import _ from 'lodash';
import { getOutputChannel } from 'src/modules/locale/components/Provider/outputChannel';

const filterPathsListWithOutputChannel = (paths: string[]) => {
  if (getOutputChannel() === 'de_DE') return paths;

  // remove /en and /de prefixes for USA and Australia
  return _.chain(paths)
    .filter((p) => !!p.match(/^en/))
    .map((p) => p.substr(3))
    .value();
};

export default filterPathsListWithOutputChannel;
